import * as React from "react";
const SvgFiRrPesoSign = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#062147"
      d="M22 9h-2.06a8.3 8.3 0 0 0 0-2H22c.55 0 1-.45 1-1s-.45-1-1-1h-2.58C18.23 2.07 15.35 0 12 0H9C6.24 0 4 2.24 4 5H2c-.55 0-1 .45-1 1s.45 1 1 1h2v2H2c-.55 0-1 .45-1 1s.45 1 1 1h2v12c0 .55.45 1 1 1s1-.45 1-1v-7h6c3.35 0 6.23-2.07 7.42-5H22c.55 0 1-.45 1-1s-.45-1-1-1M9 2h3c2.22 0 4.16 1.21 5.19 3H6c0-1.65 1.35-3 3-3M6 7h11.92c.05.33.08.66.08 1s-.03.67-.08 1H6zm6 7H6v-3h11.19A6.01 6.01 0 0 1 12 14"
    />
  </svg>
);
export default SvgFiRrPesoSign;
